const resource = '/tagline/'

export default class TaglineApi {
  private readonly axios = axiosClient

  async get(year: number): Promise<{ tagline: string }> {
    return await this.axios.$get(`${resource}?year=${year}`)
  }
}
